import { Select, SelectProps, TableProps } from "antd";
import { PropsWithChildren, ReactNode, useRef } from "react";
import { Pagination } from "../pagination";
import { ConfigProvider } from "antd";
import "./atom";
import { enI18n, zhI18n } from "../../i18n/commonTranslate";
import i18next from "i18next";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { StyledTable } from "./atom";
import { PaginationProps } from "antd/lib/pagination";
import { SimpleInterpolation } from "styled-components";

export type RenderbusTableProps<T> = PropsWithChildren<
  TableProps<T> & {
    showQuickJumper?: boolean;
    showSizeChanger?: boolean;
    showPagination?: boolean;
    total?: number;
    defaultPageSize?: number;
    paginationCurrent?: number;
    gap?: boolean;
    pageSizeOptions?: number[];
    hidePaginationOnSinglePage?: boolean;
    paginationCusomCSS?: SimpleInterpolation;
    pageSize?: number;
    hideTotal?: boolean;
    emptyText?: string;
    itemRender?: (
      page,
      type: "page" | "prev" | "next",
      originalElement
    ) => React.ReactNode;
    onPageNumChange?: (key: number) => void;
    onPageChange?: (page: number, pageSize: number) => void;
    onSelectAll?: (record: any, selected: any, selectedRows: any) => void;
    onSelect?: (record: any, selected: any, selectedRows: any) => void;
  }
>;

export function Table<T extends object = any>({
  className = "",
  dataSource,
  columns,
  showQuickJumper = true,
  showSizeChanger,
  total,
  defaultPageSize = 50,
  onPageNumChange,
  onPageChange,
  paginationCurrent,
  gap,
  scroll,
  hidePaginationOnSinglePage = false,
  showPagination = true,
  children,
  pageSize,
  pageSizeOptions,
  hideTotal,
  paginationCusomCSS,
  itemRender,
  emptyText,
  ...props
}: RenderbusTableProps<T>) {
  const i18n = i18next.language === "zh" ? zhI18n : enI18n;
  const tableRef = useRef(null);
  return (
    <ConfigProvider
      locale={i18next.language === "zh" ? zhCN : enUS}
      theme={{
        token: {
          colorText: "#FFFFFF",
        },
      }}
    >
      <StyledTable<T>
        ref={tableRef}
        locale={{
          emptyText: emptyText || i18n.emptyText,
        }}
        className={`renderbus-ui--table ${className}`}
        columns={columns}
        scroll={{ x: "max-content", ...scroll }}
        dataSource={dataSource}
        pagination={{
          position: ["none", "none"],
          pageSize: pageSize || defaultPageSize,
        }}
        getPopupContainer={(triggerNode) => tableRef.current || triggerNode}
        {...props}
      />
      {children}
      {showPagination && (
        <Pagination
          total={total}
          showQuickJumper={showQuickJumper}
          showTotal={
            !hideTotal
              ? (total) => `${i18n.tableTotalNum}${total}${i18n.tableTotalNum1}`
              : undefined
          }
          inTable
          gap={gap}
          showSizeChanger={Boolean(showSizeChanger)}
          defaultPageSize={defaultPageSize}
          pageSize={pageSize || defaultPageSize}
          onChange={onPageChange ? onPageChange : onPageNumChange}
          className={className}
          current={paginationCurrent}
          hideOnSinglePage={hidePaginationOnSinglePage}
          pageSizeOptions={pageSizeOptions}
          customCSS={paginationCusomCSS}
          itemRender={itemRender}
        />
      )}
    </ConfigProvider>
  );
}
